import SignIn from "@/components/auth/SignIn";
import SignUp from "@/components/auth/SignUp";
import ForgotPassword from "@/components/auth/ForgotPassword";
import Confirm from "@/components/auth/Confirm";
import ChangePassword from "@/components/auth/ChangePassword";
import Profile from "@/components/pages/profile/Profile";

import Dashboard from "@/components/pages/Dashboard";
import NotFoundView from "@/components/errors/NotFoundView";

import CountyServices from "@/components/partials/CountyServices";
import Services from "@/components/partials/Services";

import Businesses from "@/components/services/sbp/Businesses";
import BusinessesList from "@/components/services/sbp/BusinessesList";
import Business from "@/components/services/sbp/Business";
import AddBusiness from "@/components/services/sbp/AddBusiness";
import Parking from "@/components/services/parking/Parking";
import SeasonalParking from "@/components/services/seasonal_parking/SeasonalParking";
import Advertising from "@/components/services/advertising/Advertising";

import ComingSoon from "@/components/pages/ComingSoon";
import About from "@/components/pages/About";
import Terms from "@/components/pages/Terms";
import Billing from "@/components/billing/Billing";

const routes = [
  {
    path: "/",
    name: "SignIn",
    component: SignIn,
    meta: { guest: true }
  },
  {
    path: "/sign-up",
    name: "Signup",
    component: SignUp,
    meta: { guest: true }
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: { guest: true }
  },
  {
    path: "/confirm",
    name: "Confirm",
    component: Confirm,
    meta: { guest: true }
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    meta: { guest: true }
  },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: { auth: true },
    children: [
      {
        path: "/profile",
        name: "profile",
        component: Profile,
        meta: { auth: true }
      },
      {
        path: "/billing",
        name: "billing",
        component: Billing,
        meta: { auth: true }
      },
      {
        path: "/about",
        name: "about",
        component: About,
        meta: { auth: true }
      },
      {
        path: "/terms",
        name: "terms",
        component: Terms,
        meta: { auth: true }
      },
      {
        path: "",
        component: Services,
        meta: { auth: true },
        children: [
          {
            path: "",
            name: "services",
            component: CountyServices,
            meta: { auth: true }
          },
          {
            path: "/sbp",
            meta: { auth: true },
            component: BusinessesList,
            children: [
              {
                path: "",
                name: "sbp",
                component: Businesses,
                meta: { auth: true }
              },
              {
                path: "add-business",
                name: "addBusiness",
                component: AddBusiness,
                meta: { auth: true }
              },
              {
                path: "business/:businessId",
                name: "business",
                component: Business,
                meta: { auth: true }
              }
            ]
          },
          {
            path: "/parking",
            name: "parking",
            component: Parking,
            meta: { auth: true }
          },
          {
            path: "/land-rates",
            name: "landRates",
            component: ComingSoon,
            meta: { auth: true }
          },
          {
            path: "/house-rent",
            name: "houseRent",
            component: ComingSoon,
            meta: { auth: true }
          },
          {
            path: "/licenses",
            name: "licenses",
            component: ComingSoon,
            meta: { auth: true }
          },
          {
            path: "/seasonal-parking",
            name: "seasonalParking",
            component: SeasonalParking,
            meta: { auth: true }
          },
          {
            path: "/advertising",
            name: "advertising",
            component: Advertising,
            meta: { auth: true }
          },
          {
            path: "/park-services",
            name: "parkServices",
            component: ComingSoon,
            meta: { auth: true }
          },
          {
            path: "/cess",
            name: "cess",
            component: ComingSoon,
            meta: { auth: true }
          },
          {
            path: "/markets",
            name: "markets",
            component: ComingSoon,
            meta: { auth: true }
          }
        ]
      }
    ]
  },
  {
    path: "*",
    component: NotFoundView
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js